import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import GameSummary from './GameSummary';
import SessionProgress from './SessionProgress';
import { useNavigate } from 'react-router-dom';
import axios from '../../services/api-axios';

function GameOverModal() {
  const navigate = useNavigate();
  const openGameOverModal = useSelector((state) => state.game.openGameOverModal)
  const isOffline = useSelector((state) => state.game.isOffline)
  const { sessionActive, sessionOver, sessionId } = useSelector((state) => state.gameSession)
  const isHost = useSelector((state) => state.onlineUsers.username) === useSelector((state) => state.lobby.host)
  const [startingNext, setStartingNext] = useState(false);

  // Navigating to a different route (rather than back to /offline) ensures GameBoard
  // actually unmounts and resets game state, instead of a same-route no-op navigation.
  const homeRoute = isOffline ? '/' : '/home';

  const handleClose = () => {
    navigate(homeRoute);
  }

  const handleNavigateHome = () => {
    navigate(homeRoute);
  };

  const handleStartNextGame = () => {
    setStartingNext(true);
    axios.post(`/rest/game/session/${sessionId}/next`).catch((error) => {
      console.error(error);
      setStartingNext(false);
    });
  };

  const midSession = sessionActive && !sessionOver;

  return (
    <>
      <Modal show={openGameOverModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Game Summary</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {sessionActive && <SessionProgress/>}
          <GameSummary/>
        </Modal.Body>
        <Modal.Footer>
          {midSession && isHost && (
            <Button variant="primary" onClick={handleStartNextGame} disabled={startingNext}>
              ▶️ Start Next Game
            </Button>
          )}
          {midSession && !isHost && (
            <span className="text-muted">⏳ Waiting for host to start the next game...</span>
          )}
          <Button variant="secondary" onClick={handleNavigateHome}>
            Return to Home
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default GameOverModal;
